import styled from 'styled-components';

import { NewFilterLabel } from '@spa/shared/components/Labels/styles';
import { FilterCard } from '@spa/shared/components/Filters/styles';
import { Container as SliderContainer } from '@spa/shared/components/Slider/styles';
import { mediaMin } from '@spa/shared/theme';

export const Container = styled.div`
  ${FilterCard}
  align-items: center;
  justify-content: space-between;
  padding: ${props => props.theme.space(1)};
  margin: ${props => props.theme.space(2)};

  ${SliderContainer} {
    height: 5px;
    width: 151px;
    margin-left: auto;
  }

  svg {
    width: 20px;
    margin-right: ${props => props.theme.space(2)};

    g {
      stroke: ${props => props.theme.filter.color};
    }
  }

  span {
    display: flex;
  }

  label {
    text-align: left;
    display: flex;
    min-width: 85px;
  }

  display: flex;
  cursor: pointer;

  ${NewFilterLabel} {
    margin-left: auto;
  }

  ${mediaMin.smallBreakpoint`
    margin: 0;
    padding: ${props => props.theme.space(4)};
  `}
`;
